import { useStore } from 'framework7-react';
import { SelectedTenant } from '@/config/initialState';
import { store } from '@/config/store';
import { Customer } from '@/types/api/customerApi';
import { selectedTenantFor } from '@/utils/selectedTenant';

/**
 * 「ショッピング先」として扱う法人IDを返す。
 * テナント切り替え中は切り替え先の法人ID、未切り替え時は所属法人IDを返す。
 *
 * バナー・サービスカテゴリなど「どの法人の商品を見ているか」で決まる表示に使う。
 * 保証・車両・会員登録など「顧客がどこに所属しているか」で決まる処理には使わず、
 * customerInfo.m_affiliate_id を直接参照すること。
 */
export const useEffectiveAffiliateId = (): number => {
  const selectedTenant = useStore(store, 'getSelectedTenant') as SelectedTenant;
  const customerInfo = useStore(store, 'customerInfo') as Required<Customer>;

  // 表示中の顧客が選んだ切り替えでなければ（解除漏れの保険）所属法人で扱う
  return (
    selectedTenantFor(customerInfo.id, selectedTenant)?.m_affiliate_id ??
    customerInfo.m_affiliate_id
  );
};
